/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_FailedInputs */

const vi_einvoice_draft_failed = /** @type {(inputs: Einvoice_Draft_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tạo được hóa đơn`)
};

/**

* @param {Einvoice_Draft_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_failed = /** @type {((inputs?: Einvoice_Draft_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_failed(inputs)
});